import React, { HTMLAttributes } from 'react';
import ReactDatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';
import './date-picker.css';

interface Props {
  isClearable?: boolean;
  onChange: (date: Date) => any;
  onSelect?: (date: Date) => any;
  selectedDate: Date | undefined;
  showPopperArrow?: boolean;
  inline?:boolean;
}

const DatePicker = ({
  selectedDate,
  onChange,
  isClearable = false,
  showPopperArrow = false,
  className='defaultDateWrapperClass',
  inline=false,
  ...props
}: Props & HTMLAttributes<HTMLElement>) => {
  return (
    <ReactDatePicker
      selected={selectedDate}
      onChange={onChange}
      isClearable={isClearable}
      showPopperArrow={showPopperArrow}
      placeholderText="dd-MMM-yyyy"
      dateFormat="dd-MMM-yyyy"
      wrapperClassName={className}
      inline={inline}
      {...props}
    />
  );
};

export default DatePicker;